import { ActivityEntry } from '@/graphql/custom-types';
import {
  ActivityCancelSignupScreenDocument,
  ActivitySignupScreenDocument,
  ActivitySubscription,
  GetActivityEntryDocument,
  ScreenProfile,
} from '@/graphql/generated-types';
import { apolloClient } from '@/utils/apollo';
import SentryGraphQLError from '@/utils/exceptions/SentryGraphQLError';

const signup = async (
  profile: ScreenProfile,
  subscription: ActivitySubscription
) => {
  const response = await apolloClient.mutate({
    mutation: ActivitySignupScreenDocument,
    variables: {
      profile,
      subscription,
    },
    errorPolicy: 'all',
  });

  if (response.data?.activitySignupScreen?.success) {
    return response.data;
  }

  throw new SentryGraphQLError(`api.activities.signup`, response);
};

const cancelSignup = async (
  profile: ScreenProfile,
  subscription: ActivitySubscription
) => {
  const response = await apolloClient.mutate({
    mutation: ActivityCancelSignupScreenDocument,
    variables: {
      profile,
      subscription,
    },
    errorPolicy: 'all',
  });

  if (response.data?.activityCancelSignupScreen?.success) {
    return response.data;
  }

  throw new SentryGraphQLError(`api.activities.cancelSignup`, response);
};

const getActivityEntry = async (id: string) => {
  const response = await apolloClient.query({
    query: GetActivityEntryDocument,
    variables: {
      id,
    },
    errorPolicy: 'all',
    fetchPolicy: 'no-cache',
  });

  if (response.data?.activityEntry) {
    return response.data.activityEntry as ActivityEntry;
  }

  throw new SentryGraphQLError(`api.activities.getActivityEntry`, response);
};

export default {
  signup,
  cancelSignup,
  getActivityEntry,
};
